/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ScreeningToolDto } from './screening-tool-dto';
 /**
 *
 *
 * @export
 * @interface ScreeningExerciseDto
 */
export interface ScreeningExerciseDto {

    /**
     * Display name Unity shows for this test.
     *
     * @type {string}
     * @memberof ScreeningExerciseDto
     */
    name: string;

    /**
     * Tools used during the test. Screening always sends exactly one WEIGHT tool; omit the array or send [] for an unweighted test.
     *
     * @type {Array<ScreeningToolDto>}
     * @memberof ScreeningExerciseDto
     */
    tools: Array<ScreeningToolDto>;
}
